module.exports = __webpack_public_path__ + "img/380-3a42fc.png";